import React, { useState, useCallback, useEffect } from "react";
import { SmartCaptcha, SmartCaptchaProps } from "@yandex/smart-captcha";

type JavascriptErrorData = {
  filename: string;
  message: string;
  col: number;
  line: number;
};

interface ICaptureProps {
  setCaptureValid: React.Dispatch<React.SetStateAction<boolean>>;
}

const SubscriptionCaptcha: React.FC<ICaptureProps> = ({ setCaptureValid }) => {
  const [token, setToken] = useState("");
  const [status, setStatus] = useState("hidden");

  const handleChallengeVisible = useCallback(() => setStatus("visible"), []);
  const handleChallengeHidden = useCallback(() => setStatus("hidden"), []);

  useEffect(() => {
    if (token && status === "success") {
      setCaptureValid(true);
    }
  }, [token, status]);

  const handleSuccess = useCallback((newToken: string) => {
    setStatus("success");
    setToken(newToken);
  }, []);

  const handleTokenExpired = useCallback(() => {
    setStatus("token-expired");
    setToken("");
  }, []);

  const handleNetworkError: SmartCaptchaProps["onNetworkError"] = useCallback(
    () => setStatus("network-error"),
    []
  );

  const handleJavaScriptError: SmartCaptchaProps["onJavascriptError"] =
    useCallback((error: JavascriptErrorData) => {
      setStatus("javascript-error");
      console.error(error);
    }, []);

  return (
    <div style={{ margin: "10px 0" }}>
      <SmartCaptcha
        sitekey="ysc1_h93qUwmYiFM5Ns5ZPF73hB6Y3uE5VXufOIj5oWKn0f1264c7"
        onChallengeVisible={handleChallengeVisible}
        onChallengeHidden={handleChallengeHidden}
        onNetworkError={handleNetworkError}
        onJavascriptError={handleJavaScriptError}
        onSuccess={handleSuccess}
        onTokenExpired={handleTokenExpired}
        language="ru"
      />
    </div>
  );
};

export default SubscriptionCaptcha;
